<template>
    <div class="opera-content sku-content" iscart="0" :class="'opera-content-'+fromState">
        <i class="decrease" v-if="itemPro.quantity>0" @click="setProCount(proId,protype,-1,proLimit,speedUp,stockCount,itemPro)" :data-analysis="analysisFrom+speedUpText+'_减少_'+proName">－</i>
        <b class="num" v-if="itemPro.quantity>0">{{itemPro.quantity}}</b>
        <i class="increase " :class="proLimit>0&&proLimit<=itemPro.quantity?'unincrease':''" @click="setProCount(proId,protype,1,proLimit,speedUp,stockCount,itemPro)" :data-analysis="analysisFrom+speedUpText+'_增加_'+proName" :data-from="fromState+'-in'">＋</i>
    </div>
</template>

<script>
    import {invokeApi} from '@/resource/js/GLOBAL2'
    import {GetQueryString} from '@/resource/js/common'
    import {sa} from '@/resource/js/ANALYSIS2'


    export default{
        data(){
            return {
                analysisFrom:this.fromState=='cart'?'弹窗购物车':'首页',
                speedUpText:this.speedUp==1?'极速达':'',
            }
        },
        props:['itemPro','proId','promoId','proLimit','proName','protype','fromState','speedUp','stockCount'],
        mounted(){

        },
        methods:{
            setId(item){
                return item!=undefined?item+'-':''
            },
            setProCount(proId,pType,state,limit,speed,stockS,item){
                let isQuick = speed=='1'?true:false;
                if(state>0){
                    if(limit>0&&item.quantity>=limit){
                        return
                    }
                    item.quantity++
                    if(window.event.target.getAttribute('data-from')!='cart-in'){
                        this.addFly(window.event.target,window.event)
                    }
                }else{
                    item.quantity--
                }
                this.analysisSetPro(window.event.target.getAttribute('data-analysis'))
                this.$set(item,'quantity',item.quantity)
                this.$store.dispatch('addProCartData',{param:{salesType:pType,salesId:proId,quantity:state,areaId:'',address:'',isQuick:isQuick},pro:item,idName:'proId'})
            },
            /*add飞的动画*/
            addFly(obj,e) {
                var plus = obj;
                $('#app').append("<div class='fly'>1</div>");
                var flyElm = $(".fly").css('opacity', 0.75);
                flyElm.css({
                    'z-index': 10001,
                    'display': 'block',
                    'position': 'absolute',
                    'top': e.pageY + 'px',
                    'left': e.pageX + 'px'
                });
                flyElm.animate({
                    'top': $('.f-cart em').offset().top,
                    'left': $('.f-cart em').offset().left,
                    width: 14,
                    height: 14
                }, 'slow', function () {
                    flyElm.remove();
                });
            },
            analysisSetPro(item){
                var AnalysisState=item.split('_')[1];
                if(AnalysisState == '减少'){
                    sa.track('MinusCartBtn',{buttonPosition:item.split('_')[0],ProductName:item.split('_')[2],oos:1});
                    sa.track('AddCart',{buttonPosition:item.split('_')[0],ProductName:item.split('_')[2],oos:1});
                }else if(AnalysisState == '增加'){
                    sa.track('AddCartBtn',{buttonPosition:item.split('_')[0],ProductName:item.split('_')[2],oos:1});
                    sa.track('AddCart',{buttonPosition:item.split('_')[0],ProductName:item.split('_')[2],oos:1});

                }

            }
        }
    }
</script>

<style>
    .opera-content {
        width: 1.6rem;
        -webkit-box-align: end;
        display: -webkit-box;
        -webkit-box-pack: end;
        height: .64rem;

    }
    .opera-content-cart{
        -webkit-box-align: center;
    }

    .opera-content i {
        width: .52rem;
        height: .52rem;
        border: 1px solid #e50011;
        box-sizing: border-box;
        border-radius: .26rem;
        display: block;
        text-align: center;
        line-height: .48rem;
        font-style: normal;
        font-size: .4rem;
    }
    .opera-content-cart i{
        width: .4rem;
        height: .4rem;
        border-radius: 0;
        line-height: .4rem;
        font-size: .3rem;
    }

    .opera-content .increase {
        background: #e50011;
        color: #ffffff;
    }

    .opera-content .empty-increase {
        width: .64rem;
        height: .64rem;
        border-radius: .32rem;
        background: #e50011 url("../../resource/images/index/icon-sku-cart.png") center center no-repeat;
        background-size: .35rem .33rem;
        color: rgba(255, 255, 255, 0);
    }

    .opera-content-cart .empty-increase{
        width: .4rem;
        height: .4rem;
        border-radius: 0;
        line-height: .4rem;
        font-size: .3rem;
        background: #e50011;
        color: #ffffff;
    }
    .opera-content .unincrease {
        background: #dcdcdc;
        color: #ffffff;
        border-color: #dcdcdc;
    }

    .opera-content .decrease {
        color: #e50011;
    }

    .opera-content .undecrease {
        background: #dcdcdc;
        color: #ffffff;
        border-color: #dcdcdc;
    }

    .opera-content b {
        display: block;
        font-weight: normal;
        line-height: .52rem;
        font-size: .26rem;
        margin: 0 .16rem;
        width: .3rem;
        text-align: center;
    }

    .opera-content .hidden {
        display: none;
    }

    .store-tips {
        position: absolute;
        top: 0;
        left: 0;
        background: #ffffff;
        box-shadow: 0 0 .2rem rgba(0, 0, 0, .2);
        font-size: .2rem;
        text-align: center;
        width: 2.5rem;
        line-height: .5rem;
        -webkit-transform: translate(-.6rem, .4rem) rotate(-45deg);
    }

    .fly{
        width: .28rem;
        height: .28rem;
        background: #e50011;
        border-radius: .14rem;
        color: #ffffff;
        font-size: .2rem;
        line-height: .28rem;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/product_opera.vue